<!--
    描述：CA证书查询页面
    Created by asq
-->
<template>
	<div class="settled-enterprises-layout operation-layout" :class="{ pd0: !routeQuery }">
		<!-- 列表查询页 -->
		<filter-layout @search="searchResult" @reset="resetForm" v-if="!routeQuery">
			<template #filter>
				<el-form class="flex-row-form colspan-4" size="small" ref="searchRef" :model="searchForm" label-width="120px">
					<el-form-item label="开通单位：" prop="owner">
						<el-input v-model="searchForm.owner" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="税号：" prop="idNo">
						<el-input v-model="searchForm.idNo" placeholder="请输入"></el-input>
					</el-form-item>

					<el-form-item label="锁类型：" prop="lockType">
						<el-select v-model="searchForm.lockType">
							<el-option :value="0" label="副锁"></el-option>
							<el-option :value="1" label="主锁"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="证书状态：" prop="cerState">
						<el-select v-model="searchForm.cerState">
							<el-option :value="0" label="已废除"></el-option>
							<el-option :value="1" label="已发证"></el-option>
							<el-option :value="2" label="已归档"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</template>
			<template #content>
				<!-- 非请求参数 正常查看 -->
				<div class="operation-main">
					<div class="operation-header">
						<div class="title">
							<!-- 合计已申请CA证书：<span class="blue">{{ qyTotal }}</span> 条 -->
						</div>
						<div class="btnGroups"><el-button type="primary" class="btn-blue" size="mini" @click="doExport">导出</el-button></div>
					</div>
					<div class="operation-container w-table-layout w-table-page">
						<div class="w-table-content" v-show="tableShow">
							<el-table
								:data="tableObj.tableData"
								border
								ref="qyTable"
								highlight-current-row
								v-loading="tableObj.loading"
								@row-click="onRowClick"
								height="100%"
							>
								<el-table-column type="index" label="序号" width="60" header-align="center" align="center">
									<template slot-scope="scope">
										<span class="">{{ parseInt(scope.$index) + 1 }}</span>
										<!-- <svg-icon class="ml5"
										  icon-class="biaoqian"
										  @click="handleTagClick(scope)"></svg-icon> -->
									</template>
								</el-table-column>
								<el-table-column prop="mainType" label="主体类型" show-overflow-tooltip="" width="100" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.mainType == 0">个人</span>
										<span v-else-if="scope.row.mainType == 1">企业</span>
									</template>
								</el-table-column>
								<el-table-column prop="lockType" label="锁类型" width="120" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.lockType == 0">副锁</span>
										<span v-else-if="scope.row.lockType == 1">主锁</span>
									</template>
								</el-table-column>
								<el-table-column
									prop="owner"
									label="企业名称"
									width="240"
									show-overflow-tooltip
									header-align="center"
								></el-table-column>
								<el-table-column prop="idNo" label="税号" width="180" show-overflow-tooltip header-align="center"></el-table-column>
								<el-table-column prop="transactType" label="办理类型" width="120" align="center">
									<template slot-scope="scope">
										<span>{{ transactTypeName(scope.row.transactType) }}</span>
									</template>
								</el-table-column>

								<el-table-column
									prop="cerSerial"
									label="签名证书序列号"
									width="200"
									show-overflow-tooltip
									header-align="center"
								></el-table-column>
								<el-table-column
									prop="issueDate"
									label="证书签发时间"
									min-width="150"
									show-overflow-tooltip
									align="center"
								></el-table-column>
								<el-table-column prop="validDate" label="证书有效截止时间" min-width="200" align="center"></el-table-column>
								<el-table-column prop="cerState" label="证书状态" width="110" align="center">
									<template slot-scope="scope">
										<span  v-if="scope.row.cerState == 0">已废除</span>
										<span  v-else-if="scope.row.cerState == 1">已发证</span>
										<span v-else-if="scope.row.cerState == 2">已归档</span>
									</template>
								</el-table-column>
								<el-table-column label="操作" align="center" min-width="160">
									<template slot-scope="scope">
										<!-- <el-button
											type="primary"
											size="small"
											round
											disabled
											plain
											class="table-btn"
											v-if="roleBtns.includes('renewal')"
											@click="viewMsg(scope.row)"
										>
											<svg-icon icon-class="form-details"></svg-icon> 续费
										</el-button> -->
										<el-button
											type="primary"
											size="small"
											round
											plain
											class="table-btn"
											v-if="roleBtns.includes('detail')"
											@click="getDetail(scope.row)"
										>
											<svg-icon icon-class="form-details"></svg-icon> 查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="w-table-footer">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="pageForm.current"
								:page-sizes="[10, 20, 50, 100]"
								:page-size="pageForm.pagesize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="pageForm.total"
							>
							</el-pagination>
						</div>
					</div>
				</div>
			</template>
		</filter-layout>
		<!--详情-->
		<el-dialog :visible.sync="dialogObj.visible"
		:title="dialogObj.title"
		:width="dialogObj.width"
		class="primary-dialog"
		:close-on-click-modal="false"
		@closed="handleClosed"
		top="3vh"
		>
			<Panel :expand="true" title="办理信息">
				<el-form class="tableForm" size="medium" ref="formObjRfe" label-width="160px" :model="formObj" :show-message="false">
					<el-form-item label="主体类型">
						<span class="ml10">{{ formObj.mainType == '0' ? '个人' : formObj.mainType == '1' ? '企业' :'-'}}</span>
					</el-form-item>
					<el-form-item label="锁类型">
						<span class="ml10">{{ formObj.lockType == '0' ? '副锁' : formObj.lockType == '1' ? '主锁' :'-'}}</span>
					</el-form-item>
					<el-form-item label="企业名称" prop="sname">
						<span class="ml10">{{ formObj.owner || '-' }}</span>
					</el-form-item>
					<el-form-item label="税号" prop="sname">
						<span class="ml10">{{ formObj.idNo || '-' }}</span>
					</el-form-item>
					<el-form-item label="办理类型" prop="sname">
						<span class="ml10">{{ transactTypeName(formObj.transactType)  || '-'}}</span>
					</el-form-item>
					<el-form-item label="证书签发时间" prop="sname">
						<span class="ml10">{{ formObj.issueDate || '-' }}</span>
					</el-form-item>
					<el-form-item label="证书有效期起止时间" prop="sname">
						<span class="ml10">{{ formObj.validDate || '-' }}</span>
					</el-form-item>
					<el-form-item label="签名证书序列号" prop="sname">
						<span class="ml10">{{ formObj.cerSerial || '-' }}</span>
					</el-form-item>
					<el-form-item label="介质(KEY)序列号" prop="sname">
						<span class="ml10">{{ formObj.medSerial || '-' }}</span>
					</el-form-item>
					<el-form-item label="证书状态" prop="sname">
						<span class="ml10">{{
							formObj.lockType == '0' ? '已废除' : formObj.lockType == '1' ? '已发证' : formObj.lockType == '2' ? '已归档' : '-'
						}}</span>
					</el-form-item>
					<el-form-item label="经办人" prop="sname">
						<span class="ml10">{{ formObj.handler|| '-'}}</span>
					</el-form-item>
					<el-form-item label="经办人证件号" prop="sname">
						<span class="ml10">{{ formObj.handlerNo|| '-'}}</span>
					</el-form-item>
					<el-form-item label="办理费用" prop="sname">
						<el-input v-model="formObj.transactFee" disabled>
							<template slot="append">元</template>
						</el-input>
					</el-form-item>
					<el-form-item label="支付方式" prop="sname">
						<span class="ml10">{{ formObj.payType|| '-'}}</span>
					</el-form-item>
				</el-form>
			</Panel>
		</el-dialog>
	</div>
</template>
<script>
import { getPageCas } from "api/modules/ca";
import Panel from "components/panel/Panel";
import { exportPlus } from "utils/tools";
import { mapState } from "vuex";

export default {
	name: 'Certificate',
	components: { Panel },
	props: {},
	data() {
		return {
			searchForm: {
				owner: '',
				idNo: '',
				cerState: '',
				lockType: ''
			},
			pageForm: {
				current: 1, //当前页
				pagesize: 10, //每页条数
				total: 0 //总条数
			},
			tableObj: {
				loading: false,
				tableData: [], //表格数据数组
				height: 400
			},
			qyTotal: 0,
			searchToggle: true,
			childId: '',
			companyObj: {
				adminName: '',
				phone: '',
				createDate: '',
				isReal: '',
				openSysNames: ''
			},
			tableShow: true,
			// 标签相关
			btnLoading: false,
			curRowId: '',
			dialogObj: {
				visible: false,
				width: '1000px',
				title: '办理记录详情' //标题
			},
			formObj:{}
		}
	},
	created() {
		this.getData()
	},
	methods: {
		// 每页条数改变时
		handleSizeChange(pageSize) {
			this.pageForm.pagesize = pageSize
			this.getData()
		},

		// 当前页改变时
		handleCurrentChange(current) {
			this.pageForm.current = current
			this.getData()
		},

		// 获取所有入驻企业
		getData() {
			this.tableObj.loading = true
			getPageCas({
				current: this.pageForm.current,
				size: this.pageForm.pagesize,
				owner: this.searchForm.owner,
				idNo: this.searchForm.idNo,
				cerState: this.searchForm.cerState,
				lockType: this.searchForm.lockType
			})
				.then((d) => {
					if (d.data.pageList) {
						this.pageForm.total = parseInt(d.data.pageList.total)
						this.tableObj.tableData = d.data.pageList.records
						this.qyTotal = parseInt(d.data.pageList.total)
					} else {
						this.pageForm.total = parseInt(d.data.total)
						this.tableObj.tableData = d.data.records
						this.qyTotal = parseInt(d.data.total)
					}

					this.tableObj.loading = false
				})
				.catch((err) => {
					this.tableObj.loading = false
				})
		},

		// 搜索
		searchResult() {
			this.pageForm.current = 1
			this.getData()
		},

		// 条件筛选重置
		resetForm() {
			this.pageForm.pagesize = 10
			this.pageForm.current = 1
			if (this.$refs.searchRef) {
				this.$refs.searchRef.resetFields()
			}
			Object.keys(this.searchForm).map((x) => (this.searchForm[x] = ''))
			this.getData()
		},

		// 查看公司详情
		viewMsg(data) {
			this.childId = data.id
			this.companyObj.adminName = data.adminName
			this.companyObj.phone = data.phone
			this.companyObj.createDate = data.createDate
			this.companyObj.isReal = data.isReal
			this.companyObj.openSysNames = data.openSysNames
			this.$router.push({
				name: 'Settled-enterprises',
				query: {
					type: 'detail'
				}
			})
		},

		// 查看详情页返回
		goBack() {
			this.$router.push({ path: '/settled-enterprises' })
		},

		// 是否展开搜索区域
		changeState() {
			this.searchToggle = !this.searchToggle
		},

		// 行点击事件
		onRowClick(row) {
			this.curRowId = row.id
		},

		// 表格中点击标签图标
		handleTagClick(scope) {
			// this.tagsDialog.visible = true
			// this.tagsDialog.type = 'edit'
			// console.log(scope);
		},
		//办理类型处理
		transactTypeName(type) {
			let text = ''
			switch (type) {
				case 0:
					text = '副锁新办'
					break
				case 1:
					text = '副锁延期'
					break
				case 2:
					text = '企业主锁补办'
					break
				case 3:
					text = '企业主锁补办+企业主锁延期'
					break
				case 4:
					text = '企业主锁补办+企业主锁延期+签章重做'
					break
				case 5:
					text = '企业主锁新办'
					break
				case 6:
					text = '业主锁新办+企业主锁延期'
					break
				case 7:
					text = '企业主锁延期'
					break
				case 8:
					text = '签章重做'
					break
				case 9:
					text = '证书废除'
					break
				case 10:
					text = '证书信息变更'
					break
				case 11:
					text = '其他'
					break
			}
			return text
		},
		//查看详情
		getDetail(row){
			console.log('898989')
			this.formObj = row || {}
			this.dialogObj.visible = true
		},
		//关闭弹窗
		handleClosed(){
			this.formObj = {}
			this.dialogObj.visible = false
		},
		//导出
		doExport() {
			const params = {
				owner: this.searchForm.owner,
				idNo: this.searchForm.idNo,
				cerState: this.searchForm.cerState,
				lockType: this.searchForm.lockType
			}
			exportPlus('/ahCa/expertCas', params)
		}
	},
	computed: {
		...mapState('app', { clientSize: (state) => state.clientSize }),
		...mapState('dict', { dwxz: (state) => state.dwxz }),
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns
		}),
		routeQuery() {
			return this.$route.query.type
		}
	},
	watch: {
		// 监听 筛选元素的 切换展示 重新调整表格高度
		searchToggle() {
			this.tableShow = false
			setTimeout(() => {
				this.tableShow = true
			}, 50)
			setTimeout(() => {
				this.$refs.qyTable.doLayout()
			}, 1000)
		}
	}
}
</script>
<style lang="less" scoped>
.settled-enterprises-layout {
	/deep/ .search-form {
		.el-form-item {
			margin-bottom: 5px;
		}
	}
	.settled-enterprises-head {
		padding: 10px 20px 0 20px;
		.breadcrumb-list {
			padding: 0 15px;
			border: 1px solid #ddd;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 10px;
		}
		/deep/ .el-breadcrumb__item {
			height: 35px;
			line-height: 35px;
		}
		.el-icon-location {
			color: #009900;
			font-size: 18px;
		}
		.content-head {
			padding-bottom: 20px;
		}
		.right-align {
			text-align: right;
		}
	}
	.settled-enterprises-content {
		height: calc(100% - 50px);
		padding: 0 20px;
		.content {
			height: calc(100% - 220px);
		}
	}
	.qy-number {
		display: inline-block;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		font-size: 14px;
		border-left: 3px solid #2671cc;
		.blue {
			color: #2671cc;
			font-size: 18px;
			margin-right: 5px;
		}
	}
	.search-from {
		margin-bottom: 10px;
		border-bottom: 1px solid #2671cc;
	}
	.red {
		color: red;
	}
	.view-msg {
		color: #2671cc;
		cursor: pointer;
	}
	.ml25 {
		margin-left: 25px;
	}

	// 有表格的表单样式
	.tableForm {
		border-bottom: 1px solid #dcdcdc;
		/deep/.el-form-item {
			margin-bottom: 0;
			margin-right: 0;
			display: flex;
		}

		/deep/.el-form-item__label {
			width: 200px;
			// border: 0;
			border: 1px solid #dcdcdc;
			border-right: 0;
			border-bottom: 0;
			line-height: 46px;
			// margin: 0 1px;
			background: #fafafa;
			padding-right: 20px;
			flex-shrink: 0;
		}
		/deep/.el-form-item__content {
			border: 1px solid #dcdcdc;
			border-bottom: 0;
			flex: 1;
			margin-left: 0 !important;
			// width: calc(100% - 202px);
			background-color: #fff;
			line-height: 46px;
			text-align: left;
			overflow: hidden;
		}
		/deep/.el-form-item:last-child {
			/deep/.el-form-item__content,
			/deep/.el-form-item__label {
				border-bottom: 1px solid #dcdcdc;
			}
		}
		/deep/.el-input {
			width: 100%;
		}
		/deep/.el-input__inner {
			min-height: 46px !important;
			line-height: 46px !important;
			padding-left: 20px;
			border: 0;
			border-radius: 0;
		}
		/deep/.view-input {
			/deep/.el-input__inner {
				background-color: #fff;
				cursor: default;
			}
		}
		/deep/.el-input-number {
			width: 100%;
		}
		/deep/.el-input-number.is-controls-right .el-input-number__decrease,
		/deep/.el-input-number.is-controls-right .el-input-number__increase {
			line-height: 22px;
		}
		/deep/.vxe-switch {
			padding-left: 20px;
		}
		/deep/.el-input.is-active .el-input__inner,
		/deep/	.el-input__inner:focus {
			border: 1px solid #005CAE;
		}
		/deep/.el-date-editor .el-input__inner {
			padding-left: 30px;
		}
		/deep/.el-form-item.is-error .el-input__inner,
		/deep/.el-form-item.is-error .el-input__inner:focus,
		/deep/.el-form-item.is-error .el-textarea__inner,
		/deep/.el-form-item.is-error .el-textarea__inner:focus {
			border: 1px solid #f56c6c;
		}
		/deep/.el-select {
			width: 100%;
		}
		/deep/.el-switch,
		/deep/.el-checkbox-group,
		/deep/.el-radio-group {
			margin-left: 20px;
		}
		/deep/.el-textarea__inner {
			border: none;
			border-radius: 0;
			padding: 12px 20px;
			min-height: 46px !important;
		}
		/deep/.el-textarea .el-input__count {
			background-color: rgba(255, 255, 255, 0);
			bottom: -10px;
		}
		/deep/.el-textarea__inner:focus {
			border: 1px solid #dcdcdc;
			outline: none;
			border-color: #409eff;
		}
		/deep/.el-cascader {
			width: 100%;
		}

		/deep/.gray-append {
			.el-input-group__append,
			.el-input-group__prepend {
				background-color: #f4f7fa;
				color: #666;
				border-color: transparent;
			}
		}
		
		/deep/.el-input-group__append{
			border: none;
			border-left: 1px solid #DCDFE6;
		}
		/deep/.el-input.is-disabled .el-input__inner{
			background: #fff;
		}
	}
}
</style>

<style lang="less" scoped>
.w-table-content {
	/deep/ .el-radio__label {
		display: none;
	}
}
.primary-dialog {
	/deep/ .el-dialog__body {
		padding: 30px;
	}

	.row-label {
		height: 40px;
		line-height: 40px;
		padding-right: 15px;
	}

	.row-btn {
		padding-left: 10px;
		width: 100%;
	}

	.tags-container {
		line-height: 40px;

		/deep/ .el-tag {
			cursor: pointer;
		}
	}
}
</style>
</style>
